/* tslint:disable */
/* eslint-disable */
/**
 * Car
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Einstellwerte,
} from '../models';

export interface GetEinstellwerteRequest {
    modelId: number;
}

/**
 * 
 */
export class EinstellwerteApi extends runtime.BaseAPI {

    /**
     * Listet alle Einstellwerte auf 
     */
    async getEinstellwerteRaw(requestParameters: GetEinstellwerteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Einstellwerte>>> {
        if (requestParameters.modelId === null || requestParameters.modelId === undefined) {
            throw new runtime.RequiredError('modelId','Required parameter requestParameters.modelId was null or undefined when calling getEinstellwerte.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/einstellwerte/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters.modelId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Listet alle Einstellwerte auf 
     */
    async getEinstellwerte(requestParameters: GetEinstellwerteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Einstellwerte>> {
        const response = await this.getEinstellwerteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
